(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-rituals-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(max-width: 768px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var hero = document.querySelector('.hro');
    if (!hero) return;

    if (!document.getElementById('sk-kf')) {
      var s = document.createElement('style');
      s.id = 'sk-kf';
      s.textContent = [
        '@keyframes skFall{',
        '0%{transform:translateY(-20px) rotate(0deg);opacity:0}',
        '10%{opacity:0.4}',
        '50%{transform:translateY(45vh) translateX(20px) rotate(180deg);opacity:0.35}',
        '90%{opacity:0.15}',
        '100%{transform:translateY(95vh) translateX(-15px) rotate(360deg);opacity:0}',
        '}'
      ].join('');
      document.head.appendChild(s);
    }

    var pos = window.getComputedStyle(hero).position;
    if (pos === 'static') hero.style.position = 'relative';

    var c = document.createElement('div');
    c.id = 'sk-box';
    c.setAttribute('style',
      'position:absolute;top:0;left:0;width:100%;height:100%;' +
      'pointer-events:none;z-index:3;overflow:hidden;'
    );

    var DATA = [
      [10,7,5,11,0],[12,8,12,14,2],[8,6,20,9,5],[11,8,28,13,1],
      [9,6,35,10,7],[13,9,42,15,3],[10,7,50,12,6],[8,5,58,9,4],
      [12,8,65,14,8],[11,7,72,11,1],[9,6,78,10,9],[13,9,85,16,2],
      [10,7,91,12,5],[8,6,95,9,11],[11,8,3,13,4]
    ];

    DATA.forEach(function(d) {
      var p = document.createElement('div');
      p.setAttribute('style',
        'position:absolute;top:-20px;' +
        'left:' + d[2] + '%;' +
        'width:' + d[0] + 'px;height:' + d[1] + 'px;' +
        'background:#F2C4C4;border-radius:50% 0 50% 0;opacity:0;' +
        'animation:skFall ' + d[3] + 's ' + d[4] + 's linear infinite;' +
        'will-change:transform,opacity;pointer-events:none;'
      );
      c.appendChild(p);
    });

    hero.appendChild(c);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temoignages-rituals"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('[data-temo]').forEach(function (section) {
    var slides = section.querySelectorAll('.temo__slide');
    var dots   = section.querySelectorAll('.temo__dot');
    var current = 0;

    function goTo(idx) {
      slides[current].classList.remove('temo__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      dots[current].classList.remove('temo__dot--active');
      dots[current].removeAttribute('aria-current');

      current = idx;

      slides[current].classList.add('temo__slide--active');
      slides[current].removeAttribute('aria-hidden');
      dots[current].classList.add('temo__dot--active');
      dots[current].setAttribute('aria-current', 'true');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // Auto-advance every 6 seconds
    if (slides.length > 1) {
      setInterval(function () {
        goTo((current + 1) % slides.length);
      }, 6000);
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
